import * as styles from './styles.css';
import { Typography } from '@mui/material';
import { IComponent } from '../../../interfaces';
import { useProps } from '../../../hooks/use-props';

export interface ITextProps {
  id: string;
  title?: string;
  children?: React.ReactNode;
}

interface ITextAtom extends IComponent {
  value?: string;
}

const Text = ({ id, title, children }: ITextProps) => {
  const {
    props: { label, value, show },
  } = useProps<ITextAtom>({ id });
  if (show === false) return null;
  return (
    <div id={id} className={styles.root}>
      <Typography className={styles.title} variant={'h1'}>
        {label ?? title}
      </Typography>
      <Typography className={styles.body} variant={'body1'}>
        {value ?? children}
      </Typography>
    </div>
  );
};

export default Text;
